import APIHandler from 'config/APIHandler';

import { type FreeHotelItem, type PremiumHotelItem } from 'hooks/useDirectoryData/types.d';

export interface ListingsBounds {
  lat1: number;
  lat2: number;
  lon1: number;
  lon2: number;
}

export function isItemsResponse<T>(value: unknown): value is { items: T[] } {
  return value !== null && typeof value === 'object' && Array.isArray((value as { items?: unknown }).items);
}

export async function fetchFreeListings(
  appId: string,
  bounds: ListingsBounds,
  table: string,
  categoryParam: string,
  subcategoryParam: string,
  query: string,
  enableLocation: boolean,
): Promise<FreeHotelItem[]> {
  const results: unknown = await APIHandler.getListings(
    appId,
    bounds.lon1,
    bounds.lon2,
    bounds.lat1,
    bounds.lat2,
    table,
    categoryParam,
    subcategoryParam,
    query,
    enableLocation,
  );
  return Array.isArray(results) ? (results as FreeHotelItem[]) : [];
}

export async function fetchPremiumListings(
  appId: string,
  bounds: ListingsBounds,
  categoryParam: string,
  subcategoryParam: string,
  live: boolean | undefined,
  preview: boolean | undefined,
  enableLocation: boolean,
): Promise<PremiumHotelItem[]> {
  const premium: unknown = await APIHandler.getPremiumHotelsList(
    bounds.lat1,
    bounds.lat2,
    bounds.lon1,
    bounds.lon2,
    appId,
    categoryParam,
    subcategoryParam,
    live,
    preview,
    enableLocation,
  );
  return isItemsResponse<PremiumHotelItem>(premium) ? premium.items : [];
}
